import Box from '@zenbusiness/zui/Box';
import { superstyled } from '@zenbusiness/zui/styles';

export const PaymentReturnPageRoot = superstyled({
  name: 'PaymentReturnPage',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    minHeight: '100vh',
  }),
});

export const PaymentReturnContent = superstyled({
  name: 'PaymentReturnContent',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: 900,
    margin: '0 auto',
    padding: theme.spacing(5, 3),
  }),
});
